import { render, staticRenderFns } from "./privStaffMix.vue?vue&type=template&id=54976f0d&scoped=true&"
import script from "./privStaffMix.vue?vue&type=script&lang=js&"
export * from "./privStaffMix.vue?vue&type=script&lang=js&"
import style0 from "./privStaffMix.vue?vue&type=style&index=0&id=54976f0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54976f0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
